import React from "react";

const projects = [
  {
    emoji: "🏛️",
    type: "Gov · Enterprise",
    title: "DM-UI — Disaster Management Cell",
    desc: "Role-based Angular application covering fire safety drills, facility reporting, and public health data. Multi-path PostgreSQL scoring functions, AG Grid dashboards, and a full Angular v18→v21 migration.",
    stack: ["Angular 21", "TypeScript", "PostgreSQL", "RxJS", "AG Grid"],
    live: null,
    code: null,
    isPrivate: true,
  },
  {
    emoji: "📝",
    type: "Full-Stack · MERN",
    title: "React Blog Platform",
    desc: "A full-featured blogging application with authentication, rich text editing, and a Node.js / MongoDB backend. Responsive design with React hooks throughout.",
    stack: ["React", "Node.js", "MongoDB", "Express"],
    live: null,
    code: "https://github.com/Birlaravi/react-blog",
  },
  {
    emoji: "💸",
    type: "Full-Stack · MERN",
    title: "Expanse Management",
    desc: "Personal finance tracker with category breakdowns, monthly summaries, and data export. Node.js REST API with MongoDB storage and a clean React dashboard.",
    stack: ["React", "Node.js", "MongoDB", "Express"],
    live: "https://expansemangement.cyclic.app/",
    code: "https://github.com/Birlaravi/expanse-management",
  },
  {
    emoji: "🦠",
    type: "Frontend · Data Viz",
    title: "COVID-19 Tracker",
    desc: "Real-time global statistics dashboard pulling from a public API. Country-level filtering, chart visualisations, and a sortable data table built with React.",
    stack: ["React", "Chart.js", "REST API", "CSS3"],
    live: "https://covid19trackerbyravindra.netlify.app/",
    code: "https://github.com/Birlaravi/covid-19-tracker",
  },
];

const Projects = () => {
  return (
    <section id="projects" style={{ background: "var(--bg2)", padding: "6rem 5%" }}>
      <div className="section-inner">
        <p className="section-label">Portfolio</p>
        <h2 className="section-title">Selected projects</h2>
        <p className="section-sub">
          A mix of professional government work and personal MERN-stack builds.
        </p>
        <div className="projects-grid">
          {projects.map((p) => (
            <div key={p.title} className="project-card">
              <div className="project-img-placeholder">{p.emoji}</div>
              <div className="project-body">
                <div className="project-meta">
                  <span className="project-type">{p.type}</span>
                  <div className="project-links">
                    {p.isPrivate && (
                      <span className="project-link" title="Private repository">🔒</span>
                    )}
                    {p.code && (
                      <a href={p.code} target="_blank" rel="noopener noreferrer" className="project-link" title="GitHub">↗</a>
                    )}
                    {p.live && (
                      <a href={p.live} target="_blank" rel="noopener noreferrer" className="project-link" title="Live demo">🔗</a>
                    )}
                  </div>
                </div>
                <div className="project-title">{p.title}</div>
                <div className="project-desc">{p.desc}</div>
                <div className="project-stack">
                  {p.stack.map((t) => (
                    <span key={t} className="p-tag">{t}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
